import actionTypes from '../actionTypes';

// export function requestGames(isMobile) {
//   return {
//     type: actionTypes.GAMES_REQUEST,
//     isMobile
//   };
// }

export function successBettingGames(data) {
  return {
    type: actionTypes.BETTING_GAMES_SUCCESS,
    value: data,
  };
}

export function failBettingGames(e) {
  return {
    type: actionTypes.BETTING_GAMES_FAIL,
    exception: e,
  };
}